<template>
  <div>
    <el-upload
        :action="uploadUrl"
        :before-upload="handleBeforeUpload"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :http-request="uploadFile"
        name="file"
        :show-file-list="false"
        style="display: none"
        ref="upload"
        v-if="this.type == 'url'"
    >
    </el-upload>
    <div  class="editor" ref="editor" :style="styles" ></div>
  </div>
</template>

<script>

import Quill from "quill";
import axios from "axios";
import ImageResize from "quill-image-resize-module";
import QuillBetterTable from 'quill-better-table' // 可编辑的table

import 'quill-better-table/dist/quill-better-table.css'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";


// // 注册 resize 模块到 Quill
Quill.register({
  'modules/better-table': QuillBetterTable,
  'modules/imageResize': ImageResize,
}, true)
const Delta = Quill.import('delta');
import QuillTextIndent, { QuillTextIndentStyle } from "quill-text-indent";

Quill.register("modules/text-indent", QuillTextIndent);
Quill.register("formats/text-indent", QuillTextIndentStyle);

export default {
  name: "Editor",
  props: {
    /* 编辑器的内容 */
    value: {
      type: String,
      default: "",
    },
    /* 高度 */
    height: {
      type: Number,
      default: null,
    },
    /* 最小高度 */
    minHeight: {
      type: Number,
      default: null,
    },
    /* 只读 */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /* 上传文件大小限制(MB) */
    fileSize: {
      type: Number,
      default: 5,
    },
    /* 类型（base64格式、url格式） */
    type: {
      type: String,
      default: "url",
    }
  },
  data() {
    return {
      htmlContent: '',
      uploadUrl: process.env.VUE_APP_BASE_API + "/common/upload", // 上传的图片服务器地址
      // headers: {
      //   Authorization: "Bearer " + getToken()
      // },
      Quill: null,
      currentValue: "",
      options: {
        theme: "snow",
        bounds: document.body,
        debug: "warn",
        modules: {
          imageResize: {
            displaySize: true,
            modules: ['Resize', 'DisplaySize', 'Toolbar'] // 可选功能
          },
          "text-indent": true,
          keyboard: {
            bindings: QuillBetterTable.keyboardBindings
          },
          table: false,
          'better-table': { // 表格设置
            operationMenu: {
              items: { // 鼠标右键菜单设置,如将某一项设置false则右键菜单不会显示 如            insertColumnRight: false
                insertColumnRight: { text: '右边插入一列' },
                insertColumnLeft: { text: '左边插入一列' },
                insertRowUp: { text: '上边插入一行' },
                insertRowDown: { text: '下边插入一行' },
                mergeCells: { text: '合并单元格' },
                unmergeCells: { text: '拆分单元格' },
                deleteColumn: { text: '删除列' },
                deleteRow: { text: '删除行' },
                deleteTable: { text: '删除表格' }
              },
              background: {
                color: '#333'
              },
              color: {
                colors: ['green', 'red', 'yellow', 'blue', 'white'],
                text: '背景颜色:'
              }
            }
          },
          // imageResize: {},
          // 工具栏配置
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],       // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"],                    // 引用  代码块
              [{ list: "ordered" }, { list: "bullet" }],       // 有序、无序列表
              [{ indent: "-1" }, { indent: "+1" }],            // 缩进
              [{ size: ["small", false, "large", "huge"] }],   // 字体大小
              [{ header: [1, 2, 3, 4, 5, 6, false] }],         // 标题
              [{ color: [] }, { background: [] }],             // 字体颜色、字体背景颜色
              [{ font: []}],
              [{ align: [] }],                                 // 对齐方式
              ["text-indent"],
              ["clean"],                                       // 清除文本格式
              ["link"],                       // 链接、图片、视频
              // ['table'],
            ],
            handlers: {
              'table': function () {
                this.quill.getModule('better-table').insertTable(3, 3)
              },
              "text-indent": function() {}
            }
          }
        },
        placeholder: "请输入内容",
        readOnly: this.readOnly,
      },
    };
  },
  computed: {
    styles() {
      let style = { whiteSpace: 'pre-wrap' };
      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`;
      }
      if (this.height) {
        style.height = `${this.height}px`;
      }
      return style;
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val !== this.currentValue) {
          this.currentValue = val === null ? "" : val;
          if (this.Quill) {
            this.Quill.setContents(this.Quill.clipboard.convert({ html: this.currentValue }));
            // this.Quill.pasteHTML(this.currentValue);
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.Quill = null;
  },
  methods: {
    init() {
      const editor = this.$refs.editor;
      this.Quill = new Quill(editor, this.options);

      // 如果设置了上传地址则自定义图片上传事件
      if (this.type == 'url') {
        let toolbar = this.Quill.getModule("toolbar");
        toolbar.addHandler("link", (value) => {
          if (value) {
            this.$refs.upload.$children[0].$refs.input.click();
          } else {
            this.quill.format("link", false);
          }
        });
      }
      this.Quill.setContents(this.Quill.clipboard.convert({ html: this.currentValue }));
      // this.Quill.pasteHTML(this.currentValue);
      this.Quill.on("text-change", (delta, oldDelta, source) => {
        const html = this.$refs.editor.children[0].innerHTML;
        const text = this.Quill.getText();
        const quill = this.Quill;
        this.currentValue = html;
        this.$emit("input", html);
        this.$emit("on-change", {html, text, quill});
      });
      this.Quill.on("text-change", (delta, oldDelta, source) => {
        this.$emit("on-text-change", delta, oldDelta, source);
      });
      this.Quill.on("selection-change", (range, oldRange, source) => {
        this.$emit("on-selection-change", range, oldRange, source);
      });
      this.Quill.on("editor-change", (eventName, ...args) => {
        this.$emit("on-editor-change", eventName, ...args);
      });
      // this.addElTooltips();
// 拦截拖拽上传
      this.Quill.root.addEventListener('drop', async (e) => {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) {
          const files = e.dataTransfer.files;
          for(var file of files) {
            if (file.type.startsWith('image/')) {
              e.preventDefault();
              var p = {
                name: file.name,
                raw: file,
                status: 'ready',
                uid: new Date().getTime(),
                size: file.size
              }
              this.$refs.upload.uploadFiles = [p]
              const res = await this.uploadFile();
              this.handleUploadSuccess(res, p)
              this.$refs.upload.uploadFiles = []
            }
          }

        }
      });
      // 粘贴时把base64转换成上传
      this.Quill.on('text-change', async (delta, oldDelta, source) => {
        var quill = this.Quill
        if (source !== 'user') return; // 确保只处理用户行为
        let imageOps = [];
        let currentPosition = 0;

        delta.ops.forEach((op, index) => {
          if (op.insert && op.insert.image && typeof op.insert.image === 'string' && op.insert.image.startsWith('data:image')) {
            // 记录插入的base64图片及其位置
            imageOps.push({position: currentPosition, base64Image: op.insert.image});
          }
          // 更新当前处理的位置
          if (op.retain) {
            currentPosition += op.retain;
          } else if (op.insert) {
            if (typeof op.insert === 'string') {
              currentPosition += op.insert.length;
            } else {
              currentPosition += 1; // 插入非文本（如图片）计数为1
            }
          }
        });

        if (imageOps.length > 0) {
          var len = imageOps.length
          var count = 0
          for (const {position, base64Image} of imageOps) {
            // 计算实际位置，因为delta可能会影响内容长度
            // 上传图片到服务器
            const p = await this.handleImagePaste(base64Image, position)
            this.$refs.upload.uploadFiles = [p]
            const res = await this.uploadFile();
            this.$refs.upload.uploadFiles = []
            // // 使用新的URL替换原有的base64图片
            const change = new Delta().retain(position).delete(1)
                .insert({image: res}) // 插入新的图片链接
            quill.updateContents(change, 'silent');
            count++
          }
          if(count === len) {
            this.currentValue = this.$refs.editor.children[0].innerHTML
            this.Quill.setContents(this.Quill.clipboard.convert({ html: this.currentValue }));
          }
        }
      })

    },

    async handleImagePaste(base64Data, position) {
      // 将 base64 转为 Blob
      const res = await fetch(base64Data);
      const blob = await res.blob();
      const file = new File([blob], position+base64Data.slice(base64Data.length-11,base64Data.length)+".png", { type: 'image/png' });
      var p = {
        name: file.name,
        raw: file,
        status: 'ready',
        uid: new Date().getTime(),
        size: file.size
      }
      return p
    },
    // 上传前校检格式和大小
    handleBeforeUpload(file) {
      // 校检文件大小
      if (this.fileSize) {
        const isLt = file.size / 1024 / 1024 < this.fileSize;
        if (!isLt) {
          this.$message.error(`上传文件大小不能超过 ${this.fileSize} MB!`);
          return false;
        }
      }
      return true;
    },
    handleUploadSuccess(res, file) {
      if (file.status === 'success' || res.indexOf('TempFiles') !== -1) {
        let quill = this.Quill;
        let fileType = file.raw.type
        let length = quill.getSelection()?quill.getSelection().index:0;
        if (fileType.indexOf('image') !== -1) {
          quill.insertEmbed(length, "image", res);
        }else if (fileType.indexOf('video') !== -1) {
          // 视频类型
          quill.insertEmbed(length, "video", res);
        } else {
          quill.insertText(length, file.name);
          quill.formatText(length, file.name.length, 'link', res);
          // 创建一个链接标签，并插入文件名和链接
        }

      } else {
        this.$message.error("文件插入失败");
      }
    },
    handleUploadError() {
      this.$message.error("文件插入失败");
    },
    async uploadFile2(file1) {
      let files = [file1]
      let file_ids = []
      let list = Object.assign([], files)
      list = list.map(m => {
        this.$set(m, 'uploadProgress', 0)
        this.$set(m, 'uploadedChunks', 0)
        return m
      })
      for (const file of list) { // 使用 for...of 确保每次处理一个文件
        if (file.uploadProgress === 0) {
          const res = await this.uploadSingleFile(file); // 等待当前文件上传完成
          if (res.indexOf('上传完成') !== -1) {
            file_ids.push(res.split('上传完成')[1])
          }
        }
      }
      var fi = ''
      if (file_ids.length > 0) fi = file_ids.join(',')
      return fi
    },
    async uploadFile() {
      let files = this.$refs.upload.uploadFiles.filter(f => f.status === 'ready')
      let file_ids = []
      let list = Object.assign([], files)
      list = list.map(m => {
        this.$set(m, 'uploadProgress', 0)
        this.$set(m, 'uploadedChunks', 0)
        return m
      })
      for (const file of list) { // 使用 for...of 确保每次处理一个文件
        if (file.uploadProgress === 0) {
          const res = await this.uploadSingleFile(file); // 等待当前文件上传完成
          if (res.indexOf('上传完成') !== -1) {
            file_ids.push(res.split('上传完成')[1])
          }
        }
      }
      var fi = ''
      if (file_ids.length > 0) fi = file_ids.join(',')
      return fi
    },
    async uploadSingleFile(file) {
      const chunkSize = 1024 * 1024;
      const totalChunks = Math.ceil(file.size / chunkSize);
      if (totalChunks === 0) {
        file.uploadProgress = -1
      }
      for (let i = 0; i < totalChunks; i++) {
        const start = i * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.raw.slice(start, end);

        try {
          const res = await this.uploadChunk(chunk, i, totalChunks, file);
          file.uploadedChunks++;
          file.uploadProgress = (file.uploadedChunks / totalChunks) * 100;
          if (file.uploadProgress === 100) {
            return res
          }
        } catch (error) {
          // this.uploadTotal.fail++
        }
      }
    },
    // 上传切片
    async uploadChunk(chunk, index, total, file) {
      const formData = new FormData();
      formData.append('chunk', chunk);
      formData.append('index', index);
      formData.append('total', total);
      formData.append('filename', new Date().getTime()+'_'+file.name);
      formData.append('id', '0');
      formData.append('type', '富文本')

      const res = await axios({
        url: '/api/Gen/upload',
        method: 'POST',
        data: formData,
        // synchronous: true,
        params: {
          index,
          total,
          filename: new Date().getTime()+'_'+file.name,
          id: '0',
          type: '富文本'
        }
      })
      return res.data
    },
  }
};
</script>
<style scoped>
::v-deep .ql-editor{
  height: 100%!important;
}
</style>
<style>
.ql-first-line-indent.ql-active path {
  fill: #06c;
}
.editor, .ql-toolbar {
  white-space: pre-wrap !important;
  line-height: normal !important;
}
.ql-editor{
  line-height: 1.8;

}
.ql-editor table{
  margin: 0 auto;
}
.quill-img {
  display: none;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}
.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}
.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}
.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>
